// Update Password states
import { updatePassword, updatePasswordConfig } from './updatePassword.js'

export default function updatePasswordRoutes($stateProvider) {
  'ngInject'
  $stateProvider.state(updatePassword, updatePasswordConfig)
}
